'use strict';

frontendApp.directive('iioTagPopoverPopup', ['$rootScope', 'NotificationService', 'TagService', function ($rootScope, NotificationService, TagService) {
  return {
    restrict: 'EA',
    templateUrl: 'partials/tagging/tag_popover_popup.html',
    scope: {
      tag: '=',
      placement: '@',
      isOpen: '&'
    },

    link: function (scope, element, attrs) {

      scope.saving = false;

      scope.$watch('tag', function (val) {
        if (val) {
          // Save original version
          scope.tagColor = val.color;
          scope.tagName = val.name;
          if (!val.exclusions) {
            val.exclusions = [];
          }
          if (!val.children) {
            val.children = [];
          }
          if (!val.inverses) {
            val.inverses = [];
          }
        }
      });

      scope.close = function () {
        $rootScope.$broadcast('iioPopoverClose');
        scope.tag.color = scope.tagColor;
        scope.tag.name = scope.tagName;
      };

      scope.save = function () {
        scope.saving = true;
        var tag = TagService.AsResource(scope.tag);
        tag.$update(function (tag, putResponseHeaders) {
          scope.saving = false;
          scope.tagColor = scope.tag.color;
          scope.tagName = scope.tag.name;

          NotificationService.addSuccess({
            title: 'Tag Updated',
            description: tag.name,
            timeout: 2500
          });
          scope.close();
        }, function () {
          scope.saving = false;
        });
      };

      scope.text = function () {
        TagService.CreateText(scope.tag)
          .success(function (response, status) {
            scope.close();
          });
      };

    }
  };

}]);

